export default {
  root: ({ props, context }) => ({
    class: [
      "inline-flex select-none align-bottom outline-transparent before:rounded-full",
      "border rounded-full [&>button]:rounded-none [&>button]:text-sm [&>button]:before:rounded-full [&>button]:border-none",
      "[&>button:first-child]:border-r-none [&>button:first-child]:rounded-r-none [&>button:first-child]:rounded-tl-full [&>button:first-child]:rounded-bl-full",
      "[&>button:last-child]:border-l-none [&>button:first-child]:rounded-l-none [&>button:last-child]:rounded-tr-full [&>button:last-child]:rounded-br-full",
      "[&>[data-p-checked=true]]:before:shadow-custom [&>[data-p-checked=true]]:text-[#295BAC]",

      // Invalid State
      {
        "border-red-500 dark:border-red-400": props.invalid,
        "border-transparent": !props.invalid,
      },
    ],
  }),
};
